import React, { useEffect, useState } from "react";
import product from "../assets/product.png";
import "../styles/ProductView.css";
import { Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchAllOrdersCart, removeCart } from "../redux/ecommerce/cartSlice";
import { fetchTirms } from "../redux/getTirmsSlice";

const Terms = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tirms, status } = useSelector((state) => state.tirms);

  useEffect(() => {
    dispatch(fetchTirms({ type: "user" }));
  }, [dispatch]);

  return (
    <div className="ProductDetails mb-5">
      <div className="bg-[#FCFBFA] absolute top-0 z-0 w-full h-[110px] store"></div>
      <div className="px-20 max-lg:px-5 mt-8">
        <h2 className="text-[#14294F] text-3xl font-bold leading-relaxed mb-3">
          {t("TermsConditions")}
        </h2>
        <div className="text-[#737E91]">
          <p
            dangerouslySetInnerHTML={{
              __html: (language === "en" ? tirms.desc_en : tirms.desc)?.replace(
                /\n/g,
                "<br />"
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Terms;
